import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12zm-12-5H7v2h3.5v8h3V9H17V7h-6.5z" }));
export default createSvgIcon(iconPath, "Text");
//# sourceMappingURL=TextIcon.js.map